import { render } from "./MainLayout.vue?vue&type=template&id=66626786"
import script from "./MainLayout.vue?vue&type=script&lang=js"
export * from "./MainLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/instructor/MainLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "66626786"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('66626786', __exports__)) {
    api.reload('66626786', __exports__)
  }
  
  module.hot.accept("./MainLayout.vue?vue&type=template&id=66626786", () => {
    api.rerender('66626786', render)
  })

}


export default __exports__